/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ExceptionEntity} from "../../exception.model";

export abstract class ErrorWrapper {
    abstract transform(error: any): ExceptionEntity | null

    abstract canTransform(error: any): boolean
}
